export function selectAppType({ session }) {
  return session?.appType
}

export function selectIsAppType(type) {
  return ({ session }) => {
    return session?.appType === type
  }
}
